export default __webpack_public_path__ + "static/media/github1.9466dac4.svg";